import { GlobalEnumerationsAceIdentischmit, InstitutionDisplayModel, KontaktDisplayModel, KontaktDisplayModelFormGroup, MitantragstellerDataDisplayModel, MitantragstellerDataDisplayModelFormGroup } from '@/api/model-index';
import { AnfrageService, AusschreibungService, MitantragstellerService } from '@/api/service-index';
import { AnfrageNavigationFormComponent, MoveDirection } from '@/core/components/anfrage-navigation-form/anfrage-navigation-form.component';
import { AnfrageTransformerService } from '@/core/services/anfrage-transformer.service';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { SectionService } from '@/core/services/section.service';
import { StateService } from '@/core/services/state.service';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { Component } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'mitantragsteller-data',
    templateUrl: './mitantragsteller-data.component.html',
    styleUrls: [],
    standalone: false
})
export class MitantragstellerDataComponent extends AnfrageNavigationFormComponent {
  public mitantragstellerDataForm: MitantragstellerDataDisplayModelFormGroup;

  public InstitutionItems: InstitutionDisplayModel[] = [];

  public get formGroup(): FormGroup<any> {
    return this.mitantragstellerDataForm;
  }


  constructor(
    protected sectionService: SectionService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected portalContextService: PortalContextService,
    protected ausschreibungService: AusschreibungService,
    protected mitantragstellerService: MitantragstellerService,
    protected anfrageService: AnfrageService,
    protected stateService: StateService,
    protected loadingAnimationService: LoadingAnimationService,
    protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService,
    protected anfrageTransformerService: AnfrageTransformerService
  ) {
    super(sectionService, router, route, portalContextService);
    this.mitantragstellerDataForm = MitantragstellerDataDisplayModelFormGroup.Instance;

    this.initForm(this.route.snapshot.data.mitantragstellerData);
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.initForm(this.route.snapshot.data.mitantragstellerData);
      }
    })
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.ausschreibungService.apiAusschreibungAusschreibungIdInstitutionenGet(
      {
        ausschreibungId: this.portalContextService.CurrentAnfrage.ausschreibungId!,
        getVertretungsberechtigter: true,
      }).subscribe(institutionen => {
        if (institutionen)
          this.InstitutionItems = institutionen;
      });

    this.mitantragstellerDataForm.valueChanges.subscribe((mitantragsteller: MitantragstellerDataDisplayModel) => {
      this.updateIfIdentical(
        {
          [GlobalEnumerationsAceIdentischmit.Ansprechperson]: mitantragsteller.ansprechperson,
        },
        this.mitantragstellerDataForm.Vertretungsberechtigter
      );
    });
  }

  protected updateIfIdentical(sourceMap: { [key in GlobalEnumerationsAceIdentischmit]?: KontaktDisplayModel }, control: KontaktDisplayModelFormGroup): void {
    const identischMit: GlobalEnumerationsAceIdentischmit | undefined = control?.value?.identischmit;
    const source = identischMit ? sourceMap[identischMit] : null;
    if (source) {
      const newContact = Object.assign({}, source);
      newContact.id = null;
      newContact.identischmit = identischMit;
      control.patchValue(newContact, { emitEvent: false, onlySelf: false });
    }
  }

  protected initForm(mitantragstellerData: MitantragstellerDataDisplayModel): void {
    this.mitantragstellerDataForm.reset();
    this.mitantragstellerDataForm.CustomInstitution.valueChanges.subscribe(value => {
      if (value) {
        this.mitantragstellerDataForm.AusgewaehlteInstitutionId.disable();
        this.mitantragstellerDataForm.AusgewaehlteInstitutionId.patchValue(null);
      }
      else {
        // Enable only if the form is editable
        if (! this.mitantragstellerDataForm.disabled) {
          this.mitantragstellerDataForm.AusgewaehlteInstitutionId.enable();
        }
      }
    });

    if (!mitantragstellerData.ausgewaehlteInstitutionId && mitantragstellerData?.institution && mitantragstellerData.institution.id) {
      mitantragstellerData.customInstitution = true;
    }
    else {
      mitantragstellerData.customInstitution = false;
    }

    this.mitantragstellerDataForm.patchValue(mitantragstellerData);

    if (this.stateService.IsEndvalidationEnabled) {
      this.mitantragstellerDataForm.AusgewaehlteInstitutionId.addValidators(Validators.required);
      this.mitantragstellerDataForm.markAllAsTouched();
    }
  }

  protected save(shouldSave: boolean, moveDirection: MoveDirection): void {

    if (shouldSave && this.formGroup.dirty) {
      const mitantragstellerData: MitantragstellerDataDisplayModel = this.formGroup.value

      if (!mitantragstellerData.customInstitution)
        mitantragstellerData.institution = undefined;

      const mitantragstellerFromCache = this.portalContextService.CurrentAnfrage.mitantragsteller?.find(m => m.id == mitantragstellerData.id);
      if (mitantragstellerFromCache && (
        mitantragstellerFromCache.firstname !== mitantragstellerData.ansprechperson?.firstname ||
        mitantragstellerFromCache.lastname !== mitantragstellerData.ansprechperson?.lastname ||
        mitantragstellerFromCache.emailAddress !== mitantragstellerData.ansprechperson?.contactInformation?.emailAddress)) {

        mitantragstellerFromCache.firstname = mitantragstellerData.ansprechperson?.firstname;
        mitantragstellerFromCache.lastname = mitantragstellerData.ansprechperson?.lastname;
        mitantragstellerFromCache.emailAddress = mitantragstellerData.ansprechperson?.contactInformation?.emailAddress;
        this.anfrageTransformerService.transform(this.portalContextService.CurrentAnfrage).then(transformedAnfrage => {
          this.portalContextService.CurrentAnfrage = transformedAnfrage;
        });
      }

      this.formGroup.markAsPristine();
      if (moveDirection != MoveDirection.STAY) {
        if (this.canceledRoute) {
          this.router.navigateByUrl(this.canceledRoute);
        } else {
          this.move(moveDirection);
        }
      }

      let subscription = this.mitantragstellerService.apiMitantragstellerUpdateMitantragstellerDataAnfrageIdIdPatch({ id: mitantragstellerData.id!, anfrageId: this.anfrage.id, body: mitantragstellerData })
        .subscribe(() => {
          this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.anfrage.id }).subscribe(result => {
            this.stateService.ValidationErrors = result;
          })
        }, (error) => {
          this.formGroup.markAsDirty();
          throw error;
        });
      this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
      this.unfinishedHttpMethodsService.addSubscription(subscription);
    } else {
      this.formGroup.markAsPristine();
      this.move(moveDirection);
    }
  }

  public OnInstitutionSelectionChange(event: string): void {
    let institution = this.InstitutionItems.find(i => i.id === event);
    if (institution && institution.vertretungsberechtigter?.lastname && institution.vertretungsberechtigter.firstname) {
      this.mitantragstellerDataForm.Vertretungsberechtigter.patchValue(
        institution.vertretungsberechtigter
      );
      this.mitantragstellerDataForm.Vertretungsberechtigter.markAsDirty();
    }
  }
}
